<template>
    <div>
    <div class="">
            <div class="chat-container">
                <!-- Back Button -->
                <div class="back-button">
                    <button class="back-btn" @click="goBack" title="Back to Web WhatsApp">
                        <i class="fas fa-arrow-left"></i>
                    </button>
                </div>

                <!-- Floating Shipping Button -->
                <div class="floating-shipping-btn">
                    <button class="shipping-fab" @click="tampilCekOngkir" title="Check Shipping Cost">
                        <i class="fas fa-truck"></i>
                    </button>
                </div>

                <!-- Main Chat Area -->
                <div class="chat-main">
                    <!-- Sidebar -->
                    <ChatSidebar
                        :search-query="searchQuery"
                        :tab-active="tabActive"
                        :pending-chats="pendingChats"
                        :active-chats="activeChats"
                        :is-chat-list-loading="isChatListLoading"
                        :is-selected="isSelected"
                        :category="category"
                        :selected-category="selectedCategory"
                        @change-tab="changeTab"
                        @change-category="changeChatCategory"
                        @open-chat="openChat"
                        @receive-chat="receiveChat"
                    />

                    <!-- Message Area -->
                    <div class="message-area-container">
                        <MessageArea
                            :is-chat-loading="isChatLoading"
                            :current-chat="currentChat"
                            :chats="storeChats"
                            :is-sendable="isSendable"
                            :category="category"
                            :show-scroll-button="showScrollButton"
                            :unread-count="unreadCount"
                            :hover="hover"
                            @chat-change-category="chatChangeCategory"
                            @close-current-session="closeCurrentSession"
                            @insert-order="insertOrder"
                            @hover-chat="hoverChat"
                            @unhover-chat="unhoverChat"
                            @scroll="handleScroll"
                            @scroll-to-bottom="scrollToBottom"
                        />

                        <!-- Message Input -->
                        <MessageInput
                            :is-sendable="isSendable"
                            :message="message"
                            :autotext="autotext"
                            :bottom-css="bottomCSS"
                            :is-typing="isTyping"
                            :char-count="charCount"
                            @update:message="message = $event"
                            @attach-file="attachFile"
                            @add-emoji="addEmoji"
                            @update-file="updateFile"
                            @send-message="sendMessage"
                        />
                                </div>
                            </div>

                <!-- Modals -->
                <InsertOrderModal
                    :order-form="orderForm"
                    @insert-order-form="insertOrderForm"
                />

                <ShippingModal
                    :list-toko="listToko"
                    :provinces="provinces"
                    :cities="cities"
                    :subdistricts="subdistricts"
                    :province="province"
                    :city="city"
                    :kec-tujuan="kec_tujuan"
                    :is-province-loading="isProvinceLoading"
                    :is-city-loading="isCityLoading"
                    :is-subdistrict-loading="isSubdistrictLoading"
                    :data-kurir="dataKurir"
                    :ongkir="ongkir"
                    :kode-kurir="kodeKurir"
                    @calculate-shipping="hitungOngkir"
                    @copy-shipping="copyOngkir"
                />
								</div>
							</div>
    </div>
</template>

<script>
    import moment from 'moment'

// Import new components
import ChatSidebar from '@/components/customer-service/ChatSidebar.vue'
import MessageArea from '@/components/customer-service/MessageArea.vue'
import MessageInput from '@/components/customer-service/MessageInput.vue'
import InsertOrderModal from '@/components/customer-service/InsertOrderModal.vue'
import ShippingModal from '@/components/customer-service/ShippingModal.vue'

    export default {
    name: 'Chat',
        components: {
        ChatSidebar,
        MessageArea,
        MessageInput,
        InsertOrderModal,
        ShippingModal
        },
        data() {
            return {
                deviceID: 0,
                chatLists: [],
                contacts: [],
                isSelected: [],
                currentChat: null,
                chats: [],
                fn: {},
                message: "",
                isChatListLoading: true,
                isChatLoading: false,
                isSendable: false,
                tabActive: "A",
                autotext: [],
                bottomCSS: "105px",
                hover: {},
                orderForm: {},
                category: [],
                selectedCategory: "",
                file: null,
            searchQuery: "",
                provinces: [],
    cities: [],
    province: "",
                city: "",
            kec_tujuan: "",
    subdistricts: [],
    isProvinceLoading: false,
    isCityLoading: false,
    isSubdistrictLoading: false,
            dataKurir: [
                { idx: "pos", nama: "POS Indonesia (POS)" },
                { idx: "lion", nama: "Lion Parcel (LION)" },
                { idx: "jne", nama: "Jalur Nugraha Ekakurir (JNE)" },
                { idx: "ninja", nama: "Ninja Xpress (NINJA)" },
                { idx: "ide", nama: "ID Express (IDE)" },
                { idx: "sicepat", nama: "SiCepat Express (SICEPAT)" },
                { idx: "sap", nama: "SAP Express (SAP)" },
                { idx: "ncs", nama: "Nusantara Card Semesta (NCS)" },
                { idx: "anteraja", nama: "AnterAja (ANTERAJA)" }
            ],
            listToko: [],
            ongkir: 0,
            kodeKurir: '',
            respOngkir: '',
    isTyping: false,
    charCount: 0,
    showScrollButton: false,
    unreadCount: 0,
    lastScrollTop: 0
            };
        },
    computed: {
        pendingChats() {
            return this.$store.state.customer_service.pending_chat_lists || [];
        },
        activeChats() {
            return this.$store.state.customer_service.active_chat_lists || [];
        },
        storeChats() {
            return this.$store.state.customer_service.chats || [];
        }
    },
        beforeDestroy() {
            this.$root.$off("ws", this.fn);
        },
        watch: {
            '$store.state.customer_service.chats': function () {
                this.$nextTick(function () {
                    this.scrollToElement()
                });
            },
            message: {
                handler(val) {
                    this.autotext = []
                    this.charCount = val.length
                if (val.startsWith("/")) {
                        this.autotextSearch(val)
                    }
                }
            },
            province: {
                handler(val, old) {
                    if (val?.province_id && val?.province_id != old) {
                        this.loadCityData(val?.province_id)
                        this.city = null
                        this.cities = []
                        this.subdistricts = []
                    }
                },
                deep: true
            },
            city: {
                handler(val, old) {
                    if (val?.city_id && val?.city_id != old) {
                        this.loadSubdistrictData(val?.city_id)
                        this.subdistricts = []
                    }
                },
                deep: true
            },
        },
        async mounted() {
            this.deviceID = this.$route.params.id

            this.fn = async (param) => {
            if (param == "pong") return
                param = JSON.parse(param)
                if (param.event == "incoming") {
                    if (param.data.message.device_id == this.deviceID) {
                        //CHECK ACTIVE CHAT LIST
                        let activeChatLists = this.$store.state.customer_service.active_chat_lists ?? []
                        let chatLists
                        let flag = false

                        let find = await activeChatLists?.findIndex(a => a.jid == param.data.message.jid)

                    if (find != -1) {
                            chatLists = activeChatLists
                            //PUSH TO ACTIVE
                    } else {
                            chatLists = this.$store.state.customer_service.pending_chat_lists ?? []
                            //PUSH TO PENDING
                        }

                        let newChat = {
                            jid: param.data.message.jid,
                            last_chat: {
                                text: param.data.message.text,
                                file: param.data.message.file,
                                from_me: param.data.message.from_me
                            },
                            last_update: param.data.message.created_at,
                            number: param.data.message.number,
                            notification: 1
                        }

                        for (let i = 0; i < chatLists.length; i++) {
                            if (chatLists[i].jid == param.data.message.jid) {
                                newChat.notification = chatLists[i].notification + 1
                                chatLists.splice(i, 1)
                                flag = true
                            }
                        }

                    if (param.data.message.jid == this.currentChat?.jid) {
                            let chats = this.$store.state.customer_service.chats
                            chats.push(param.data.message)
                            this.$store.commit("PUSH_HISTORY_CHATS_CS", chats)

                            newChat.notification = 0
                        }

                        let resp = true
                    if (flag == false) {
                            resp = await this.validateSession(newChat.jid)
                        }

                    if (resp) {
                            chatLists = [newChat, ...chatLists]

                        if (find != -1) {
                                this.$store.commit("PUSH_HISTORY_CHAT_LISTS_CS_ACTIVE", chatLists)
                        } else {
                                this.$store.commit("PUSH_HISTORY_CHAT_LISTS_CS_PENDING", chatLists)
                            }
                        }
                    }
            } else if (param.event == "refresh") {
                if (param.data.refresh == "PENDING_CHAT_LIST") {
                        await this.getPendingChatLists()
                        await this.getActiveChatLists()

                    if (param.data.jid == this.currentChat?.jid) {
                            await this.resetChat()
                        }
                    }
                }
            }
            this.$root.$on("ws", this.fn);

            this.getCategory()
            await this.getContact()
            await this.getPendingChatLists()
            await this.getActiveChatLists()
        },
        methods: {
        // Navigation methods
        goBack() {
            this.$router.push('/cs-page/web-whatsapp');
        },
        // Shipping methods
        copyOngkir(idx) {
            let hasil = 'Asal: ' + this.respOngkir.origin_details.subdistrict_name + ',' + this.respOngkir.origin_details.city + ', ' + this.respOngkir.origin_details.province
            hasil += '\nTujuan: ' + this.respOngkir.destination_details.subdistrict_name + ',' + this.respOngkir.destination_details.city + ', ' + this.respOngkir.destination_details.province
            hasil += '\nBerat: ' + this.respOngkir.query.weight + ' gram'
            hasil += '\nKurir: ' + this.respOngkir.results[0].code.toUpperCase()
            hasil += '\nLayanan: ' + this.respOngkir.results[0].costs[idx].service + '(' + this.respOngkir.results[0].costs[idx].description + ')'
            hasil += '\nEstimasi: ' + this.respOngkir.results[0].costs[idx].cost[0].etd + ' hari'
            hasil += '\nHarga: ' + this.respOngkir.results[0].costs[idx].cost[0].value
            hasil += '\nCatatan: ' + this.respOngkir.results[0].costs[idx].cost[0].note
				
				navigator.clipboard.writeText(hasil);
			},
        async hitungOngkir() {
				let frmHitungOngkir = document.getElementById('frmHitungOngkir'); 
				let formData = new FormData(frmHitungOngkir)
            var hasil = "{";
            let nilai = ''
				for (let [key, value] of formData) {
                if (value.length == 0 || value == 0) {
						alert("nilai " + key + " harus diisi ")
						return
					}
                if (key == 'origin') {
						nilai = value.split("-")
						value = nilai[2]
					}
					
						hasil += `"${key}": "${value}",`;
				}
				
            hasil += `"destination": "${this.kec_tujuan.subdistrict_id}"`
				
            hasil += "}"
				
            let ongkos = await this.$store.dispatch("ambilOngkir", JSON.parse(hasil))
				this.respOngkir = ongkos.data.data.ongkir.rajaongkir
				this.ongkir = ongkos.data.data.ongkir.rajaongkir.results[0].costs
            this.kodeKurir = ongkos.data.data.ongkir.rajaongkir.results[0].code.toUpperCase()
				console.log(ongkos.data.data.ongkir.rajaongkir)
			},
        async getCategory() {
                let cat = await this.$store.dispatch("category_all", {})
                this.category = cat.data.data.categories
            },
        async chatChangeCategory() {
                await this.$store.dispatch("customer_service_update_category", {
                    id: parseInt(this.currentChat.id),
                    category: this.currentChat.category,
                });
            },
        async changeChatCategory(category) {
                this.selectedCategory = category
                await this.getPendingChatLists(category)
                await this.getActiveChatLists(category)
            },
        getCategoryButtonClass(category) {
            if (this.selectedCategory == category) {
                    return "btn btn-info btn-sm"
            } else {
                    return "btn btn-outline-info btn-sm"
                }
            },
        async insertOrderForm() {
            try {
                    let data = {
                        number: this.currentChat.number, 
                        deviceID: parseInt(this.deviceID),
                        data: this.orderForm
                    }
                    
                    let response = await this.$store.dispatch('order_create', data)

                    this.$toast.success(response.data.message);
                    this.$root.$emit("toggle_modal", "insert_order")
            } catch (err) {
                    this.$root.$emit("toggle_modal", "insert_order")
                    this.$toast.error(err.response.data.message);
                }
            },
            insertOrder(idx) {
                this.orderForm = []
                
                let msg = this.$store.state.customer_service.chats[idx]
                const textLine = msg?.text?.split(/\r?\n/);
                textLine.forEach((text) => {
                    const data = this.getData(text);
                    if (data) {
                        this.orderForm.push({
                            key: data[0],
                            value: data[1]
                        })
                    }
                });

            if (this.orderForm.length == 0) {
                    this.$toast.error("Tidak bisa parsing pesan")
            } else {
                    this.$modal.toggle("insert_order");
                }
            },
        async ambilToko() {
				try {
                    let toko = await this.$store.dispatch("ambil_toko")
                this.listToko = []
					this.listToko.push({
                            id: 0,
                            label: "Pilih Toko"
                        })
					for (let i = 0; i < toko.data.data.origins.length; i++) {
                        let element = toko.data.data.origins[i];
                        this.listToko.push({
                            id: element.origin,
                            label: element.name
                        })
                    }
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                }
			},
        async tampilCekOngkir() {
				this.$modal.toggle("cek_ongkir");
				this.ambilToko()
				try {
                    let detail = await this.$store.dispatch("rajaongkir_province")
                    this.provinces = detail.data.data.provinces
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                }
			},
			async loadCityData(id) {
                this.isCityLoading = true
                try {
                    this.cities = []

                    let detail = await this.$store.dispatch("rajaongkir_city", {
                        id
                    })

                    for (let i = 0; i < detail.data.data.cities.length; i++) {
                        const element = detail.data.data.cities[i];
                        this.cities.push({
                            city_id: element.city_id,
                            label: element.type + " " + element.city_name
                        })
                    }
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                }
                this.isCityLoading = false
            },
			async loadSubdistrictData(id) {
                this.isSubdistrictLoading = true
                try {
                    this.subdistricts = []

                    let detail = await this.$store.dispatch("rajaongkir_subdistrict", {
                        id
                    })
                    this.subdistricts = detail.data.data.subdistricts
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                }
                this.isSubdistrictLoading = false
            },
            getData(text) {
                if (!text.includes(":")) return null;
                const label = text.substr(0, text.indexOf(":")).trim();
                const value = text.substr(text.indexOf(":") + 1).trim();
                return [label, value];
            },
            formatDateRelative(unix) {
                return moment(unix).fromNow()
            },
            formatDateDetail(unix) {
                return moment(unix).format("LLL")
            },
        async getContact() {
            try {
                    let res = await this.$store.dispatch("contact_load_from_device", {
                        id: parseInt(this.deviceID)
                    });

                    this.$store.commit("PUSH_HISTORY_CONTACTS", res.data.data.contacts)
            } catch (err) {
                    console.log(err)
                }
            },
        getName(jid, number) {
                let contacts = this.$store.state.history.contacts
                for (let i = 0; i < contacts.length; i++) {
                    let formattedNumber = this.formatNumber(contacts[i].number, contacts[i].is_group)
                if (formattedNumber == jid) {
                    if (contacts[i].name != "") {
                            return contacts[i].name
                    } else {
                            return contacts[i].number
                        }
                    }
                }

                return number
            },
            async getPendingChatLists(category = "") {
                this.isChatListLoading = true
                let res = await this.$store.dispatch("customer_service_pending_chat_lists", {
                    id: parseInt(this.deviceID),
                    category
                });
                this.$store.commit("PUSH_HISTORY_CHAT_LISTS_CS_PENDING", res.data.data.chat_lists)

                this.isChatListLoading = false
            },
            async getActiveChatLists(category = "") {
                this.isChatListLoading = true
                let res = await this.$store.dispatch("customer_service_active_chat_lists", {
                    id: parseInt(this.deviceID),
                    category
                });
                this.$store.commit("PUSH_HISTORY_CHAT_LISTS_CS_ACTIVE", res.data.data.chat_lists)

                this.isChatListLoading = false
            },
            async getChats(jid) {
                let res = await this.$store.dispatch("customer_service_chats", {
                    id: parseInt(this.deviceID),
                    jid: jid
                });

                return res.data.data.chats
            },
            updateFile(e) {
            this.file = e;
        },
        attachFile() {
            // Handle file attachment
            console.log('Attach file clicked');
        },
        addEmoji() {
            // Handle emoji addition
            console.log('Add emoji clicked');
        },
        async sendMessage() {
            if (this.message == "") {
                    return
                }
                
                let text = this.message 
                let number = this.currentChat.number
                this.message = ""

                let url = ""
            if (this.file) {
					let formData = new FormData();
					formData.append('file', this.file)
					let response = await this.$store.dispatch('cdn_upload', formData)
					url = response.data.data.url
				}

                let finalMessage = {
                    device_id: parseInt(this.deviceID),
                    schedule: moment().utc().valueOf(),
                    broadcast: [{
                        message_type: "text",
                        to: number,
                        text: text,
                        file: url,
                        delay: 0,
                    }]
                }

            try {
                    await this.$store.dispatch('cs_outgoing_send', finalMessage)

                    let chats = this.$store.state.customer_service.chats
                    chats.push({
                        device_id: parseInt(this.deviceID),
                        from_me: 1,
                        jid: this.currentChat.jid,
                        number: number,
                        text: text,
                        created_at: finalMessage.schedule,
                        updated_at: finalMessage.schedule
                    })
                    this.$store.commit("PUSH_HISTORY_CHATS_CS", chats)

                    let activeChatLists = this.$store.state.customer_service.active_chat_lists ?? []

                    let lastChatIndex = activeChatLists.findIndex(a => a.jid == this.currentChat.jid)
                    activeChatLists[lastChatIndex].last_chat.text = text
                    activeChatLists[lastChatIndex].last_update = finalMessage.schedule

                    this.$store.commit("PUSH_HISTORY_CHAT_LISTS_CS_ACTIVE", activeChatLists)

            } catch (err) {
                    this.$toast.error("Error to sending message")
                }
            },
        formatNumber(number, is_group) {
            if (number.charAt(0) == "0") {
                    number = "62" + number.substring(1)
                }

            if (is_group) {
                    number = number + "@g.us"
            } else {
                    number = number + "@s.whatsapp.net"
                }

                return number
            },
        resetChat() {
                this.isSendable = false
                this.currentChat = null
                this.$store.commit("PUSH_HISTORY_CHATS_CS", [])
                this.isChatLoading = false
                this.isSelected = []
            },
        async openChat(data) {
            const { jid, sendable } = data;
            if (this.currentChat?.jid == jid) return

                this.isSendable = sendable
                this.isChatLoading = true

                this.select(jid)
                this.currentChat = {}

                let chatLists = []
            if (this.tabActive == 'A') {
                    chatLists = this.$store.state.customer_service.pending_chat_lists ?? []
            } else {
                    chatLists = this.$store.state.customer_service.active_chat_lists ?? []
                }
                this.currentChat = await chatLists.find(a => a.jid == jid)

                this.currentChat.name = this.getName(this.currentChat.jid, this.currentChat.number)
                let chats = await this.getChats(jid)
                this.$store.commit("PUSH_HISTORY_CHATS_CS", chats)

                let lastChatIndex = chatLists.findIndex(a => a.jid == jid)
                chatLists[lastChatIndex].notification = 0

            if (this.tabActive == 'A') {
                    this.$store.commit("PUSH_HISTORY_CHAT_LISTS_CS_PENDING", chatLists)
            } else {
                    this.$store.commit("PUSH_HISTORY_CHAT_LISTS_CS_ACTIVE", chatLists)
                }

                this.isChatLoading = false
                
                // Scroll to bottom after chat is loaded
                this.$nextTick(() => {
                    this.scrollToBottom()
                })
            },
        async receiveChat(jid) {
            try {
                    await this.$store.dispatch("customer_service_receive_chats", {
                        id: parseInt(this.deviceID),
                        jid: jid
                    });

                    this.$toast.success("Berhasil terima chat")
            } catch (err) {
                    this.$toast.error(err.response.data.message)
                }
            },
        async closeCurrentSession() {
            try {
                    await this.$store.dispatch("customer_service_close_chats", {
                        id: parseInt(this.deviceID),
                        jid: this.currentChat.jid
                    });
                    this.resetChat()
                    this.$toast.success("Berhasil tutup session chat")
            } catch (err) {
                    this.$toast.error(err.response.data.message)
                }
            },
        async validateSession(jid) {
            try {
                    await this.$store.dispatch("customer_service_validate", {
                        id: parseInt(this.deviceID),
                        jid: jid
                    });

                    return true
            } catch (err) {
                    return false
                }
            },
        async autotextSearch(q) {
                this.autotext = []

            try {
                    q = q.substring(1);
                    let search = await this.$store.dispatch('autotext_search', q)
                    let start = 105
                    for (let i = 0; i < search.data.data.autotexts.length; i++) {
                        const element = search.data.data.autotexts[i]
                        this.autotext.push(element.autotext)

                        start += 65
                    }

                    start -= 65

                    this.bottomCSS = start + "px"
            } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            select(id) {
                this.isSelected = []
            if (this.isSelected.includes(id)) {
                this.isSelected = this.isSelected.filter(s => s !== id)
                } else this.isSelected.push(id)
            },
        trimString(string, length) {
            if (string == null || string == "") {
                    return ""
                }
                return string.length > length ? string.substring(0, length) + '...' : string;            
            },
            scrollToElement() {
                this.$nextTick(() => {
                    // Try multiple selectors to find the messages container
                    const selectors = [
                        ".chat-messages-container",
                        ".messages-container", 
                        ".chat-window",
                        ".message-area-container"
                    ];
                    
                    let container = null;
                    for (const selector of selectors) {
                        container = this.$el.querySelector(selector);
                        if (container) break;
                    }
                    
                    if (container) {
                        // Check if user is near bottom (within 100px)
                        const isNearBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 100;

                        // Only auto-scroll if user is near bottom
                        if (isNearBottom) {
                            container.scrollTo({
                                top: container.scrollHeight,
                                behavior: 'smooth'
                            });
                            this.unreadCount = 0;
                        } else {
                            // Increment unread count for new messages
                            this.unreadCount += 1;
                        }
                    }
                });
            },
        changeTab(tab) {
                this.tabActive = tab
            },
        countChatLists(obj) {
            try {
                    return obj.length
            } catch (err) {
                    return 0
                }
            },
        hoverChat(idx) {
                this.hover = {
                    idx,
                }
            },
        unhoverChat() {
                this.hover = {
                    idx: null
                }
            },
        getHoverChat(idx) {
            if (this.hover.idx == idx) {
                    return true
            } else {
                    return false
                }
            },
            handleScroll() {
                const container = this.$el.querySelector(".chat-messages-container");
                if (container) {
                    const scrollTop = container.scrollTop;
                    const scrollHeight = container.scrollHeight;
                    const clientHeight = container.clientHeight;

                    // Show scroll button if user scrolled up more than 100px from bottom
                    const isNearBottom = scrollHeight - scrollTop - clientHeight < 100;
                    this.showScrollButton = !isNearBottom;

                    // Update unread count based on scroll position
                    if (isNearBottom) {
                        this.unreadCount = 0;
                    }

                    this.lastScrollTop = scrollTop;
                }
            },
            scrollToBottom() {
                // Try multiple selectors to find the messages container
                const selectors = [
                    ".chat-messages-container",
                    ".messages-container", 
                    ".chat-window",
                    ".message-area-container"
                ];
                
                let container = null;
                for (const selector of selectors) {
                    container = this.$el.querySelector(selector);
                    if (container) break;
                }
                
                if (container) {
                    container.scrollTo({
                        top: container.scrollHeight,
                        behavior: 'smooth'
                    });
                    this.showScrollButton = false;
                    this.unreadCount = 0;
                } else {
                    // Fallback: scroll the entire page
                    window.scrollTo({
                        top: document.body.scrollHeight,
                        behavior: 'smooth'
                    });
                }
            },
        },
    };
</script>

<style scoped>
/* Main Container */
.chat-container {
        height: 100vh;
        display: flex;
        flex-direction: column;
    background: #fafafa;
        overflow: hidden;
    position: relative;
}

/* Back Button */
.back-button {
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: 1000;
}

.back-btn {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #1976d2;
    border: none;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.125rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 0 12px rgba(0, 0, 0, 0.15);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.back-btn:hover {
    background: #1565c0;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25), 0 0 16px rgba(0, 0, 0, 0.2);
    transform: scale(1.05);
}

.back-btn:active {
    transform: scale(0.95);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Floating Shipping Button */
.floating-shipping-btn {
    position: fixed;
    bottom: 90px;
    left: 20px;
    z-index: 1000;
}

.shipping-fab {
    width: 56px;
    height: 56px;
        border-radius: 50%;
    background: #1976d2;
        border: none;
        color: white;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
            font-size: 1.25rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 0 12px rgba(0, 0, 0, 0.15);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.shipping-fab:hover {
    background: #1565c0;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25), 0 0 16px rgba(0, 0, 0, 0.2);
    transform: scale(1.05);
}

.shipping-fab:active {
    transform: scale(0.95);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    /* Main Chat Area */
.chat-main {
        flex: 1;
        display: flex;
        min-height: 0;
        overflow: hidden;
    background: #fafafa;
    }

/* Message Area Container */
.message-area-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
    }

/* Responsive Design */
    @media (max-width: 768px) {
    .chat-container {
            height: 100vh;
            overflow: hidden;
        }

    .back-button {
        bottom: 80px;
        left: 16px;
    }

    .back-btn {
        width: 44px;
        height: 44px;
        font-size: 1rem;
    }

    .floating-shipping-btn {
        bottom: 16px;
        left: 16px;
    }

    .shipping-fab {
        width: 48px;
        height: 48px;
        font-size: 1.125rem;
    }

    .chat-main {
            flex-direction: column;
        }
    }
</style>
